<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { ref } from "vue";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isActive = ref(false);
const toggle = () => {
    isActive.value = !isActive.value;
    updateScrolling();
};

const updateScrolling = () => {
    ScrollTrigger.refresh(true);
};
</script>

<template>
    <slot v-bind="{ isActive, toggle, updateScrolling }" />
</template>
